<template>
    <div class="detailcontainer">
        <div v-if="curVolun">
            <div class="elder">
                <a-avatar :size="120" :src="curVolun.avatar" />
                <a-descriptions title="Elder Info">
                    <a-descriptions-item label="UserName">{{
                        curVolun.username
                    }}</a-descriptions-item>
                    <a-descriptions-item label="Email">{{
                        curVolun.email
                    }}</a-descriptions-item>
                    <a-descriptions-item label="Age">{{
                        GetAgeFromBirth(curVolun.birthday)
                    }}</a-descriptions-item>
                    <a-descriptions-item label="Job">{{
                        curVolun.job
                    }}</a-descriptions-item>
                    <a-descriptions-item label="Interests">
                        <a-tag v-for="(item, index) in curVolun.interests" :key="index">{{ item }}</a-tag>
                    </a-descriptions-item>
                </a-descriptions>
            </div>
            <h1>Current Matched Elder</h1>
            <a-empty v-if="!currentMatch"> Current No Matched Volunteer</a-empty>
            <div v-else>
                <a-list :grid="{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 6, xxl: 3 }" :data-source="currentMatch"
                    class="box">
                    <a-list-item slot="renderItem" slot-scope="item">
                        <a-card :title="item.username">
                            <a-avatar :size="120" :src="item.avatar"></a-avatar>
                            <span>Email: <strong>{{ item.email }}</strong></span>
                            <br />
                            <span>Province: {{ item.province }}</span>
                            <br />
                            <span>Age: {{ GetAgeFromBirth(item.birthday) }}</span>
                            <br />
                            <span>Interests:
                                <a-tag v-for="each in item.interests" :key="each">{{ each }}</a-tag>
                            </span>
                            <br />
                            <span>
                                Industry: <strong>{{ item.job }}</strong>
                            </span>
                            <br />
                        </a-card>
                    </a-list-item>
                </a-list>
            </div>
        </div>
        <div v-else>
            <a-result status="404" title="404" sub-title="Sorry, the page you visited does not exist.">
                <template #extra>
                    <a-button @click="$router.replace('/admin/elder')" type="primary">Back Home</a-button>
                </template>
            </a-result>
        </div>
    </div>
</template>
  
<script>
import { mapGetters,  } from "vuex";
import {getmatchedForVolunteer} from '../../api'
import dayjs from "dayjs";
export default {
    data() {
        return {
            currentMatch: []
        };
    },

    methods: {
        GetAgeFromBirth(birth) {
            return dayjs().year() - Number(birth)
        },
    },

    computed: {
        ...mapGetters({
            loading: "admin/loading",
            curVolun: "admin/curVolun",
            volunteerList: "admin/volunList"
        }),
    },
    async mounted() {
        console.log(this.curVolun)
        if (this.curVolun) {
            if (this.curVolun.matched) {
                this.currentMatch = await getmatchedForVolunteer(this.curVolun.uid)
            }
        }
    },
};
</script>
  
<style lang='less' scoped>
.detailcontainer {
    width: 60%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 2vw;
    justify-content: flex-start;
    align-items: center;

    .elder {
        margin-bottom: 1vw;
    }

    .meetInfo {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        h2 {
            font-size: 1.6rem;
            font-weight: 600;
        }

        .core {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;

            div {
                padding: 0.5vw 2vw;

                span {
                    font-size: 1.2rem;
                    color: black;
                    font-weight: 700;

                    span {
                        font-weight: 600;
                        font-size: 1rem;
                    }
                }
            }
        }
    }

    .ava {
        width: 100%;
        height: 50vh;
    }

    .volunteer {
        position: fixed;
        right: 0;
        top: 0;
        width: 30vw;
        border-left: 1px solid;
        bottom: 0;
        overflow: scroll;
        padding: 1vw;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .header {
            margin-bottom: 1vw;
            display: flex;
            width: 100%;
            flex-direction: column;
            justify-content: flex-start;
            align-items: space-between;
        }

        .choice {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: space-between;
        }
    }
}

.info {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 1vw;

    img {
        border-radius: 50%;
        width: 5vw;
        height: 5vw;
        object-fit: contain;
    }

    .content {
        margin-left: 1vw;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        span {
            font-size: 1rem;
        }

        .tags {
            display: flex;
            flex-direction: row;
            align-items: center;

            .toal {
                margin-left: 1vw;
                display: flex;
                flex-direction: row;
                align-items: center;
                flex-wrap: wrap;
            }
        }
    }
}
</style>